import {useState} from "react";
import {Box, Button, Card, CardActionArea, CardContent, Typography, useMediaQuery} from "@mui/material"
import Grid from '@mui/material/Grid2'
import {useNavigate} from "react-router-dom";

import {styles} from './homeFooterCard-helpers';
import {caringForSomeoneWithGeographicAtrophy, livingWithGeographicAtrophyLeaflet,gaVideoUrl} from "../../../../assets/data";
import roundBack from '../../../../assets/images/svgs/roundBackIcon.svg'
import gaImage from '../../../../assets/images/other/home/identifying_footer.png'
import patientsImage from '../../../../assets/images/other/home/patients_footer.png'
import detectionImage from '../../../../assets/images/other/home/detection_footer.jpg'
import supportingSomeoneWithGaImage from '../../../../assets/images/other/home/caring-for-someone-with-ga.png'
import livingWithGaImage from '../../../../assets/images/other/home/living-with-ga.png'

import {theme} from "../../../../utils";
import {downloadFile} from "../../../common.helper";
import {VideoDialog} from "../DemoDialog";


export const HomeFooterCard = () => {
    const navigate = useNavigate()
    const isMobile = useMediaQuery(theme.breakpoints.down(950))
    const [showDemoVideo, setShowDemoVideo] = useState(false)

    const downloadHandler = async (pdfUrl: string) => {
        downloadFile(pdfUrl)
    }

    const contentCards = [
        {
            imageSource: gaImage,
            title: "Identifying Early Signs of GA",
            type: "Article",
            id: 0
        },
        {
            imageSource: patientsImage,
            title: "A Patient’s Journey",
            type: "Video",
            id: 1
        },
        {
            imageSource: detectionImage,
            title: "Imaging — Detection and Progression",
            type: "Article",
            id: 2
        },
    ]

    const handleCardClick = (card: any) => {
        if (card.id === 1) {
            setShowDemoVideo(true)
        } else {
            navigate(`/education-hub?tabPath=${card.id}`)
        }
    }

    return (
        <Box sx={{
            ...styles.gradientBg,
            marginTop: '30px',
            pt: 0,
            mb: 0,
            pb: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start'
        }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    py: 2,
                }}
            >
                <Typography sx={{...styles.cardItemMainTitle, color: '#fff'}}>
                    How Geographic Atrophy Can Affect Vision
                </Typography>
            </Box>
            <Box sx={{display: 'flex', flexDirection: isMobile ? 'column' : 'row'}}>
                {/* LEFT SIDE */}
                <Box
                    sx={{
                        flex: 1,
                        position: 'relative',
                        aspectRatio: '16 / 9',
                        overflow: 'hidden',
                    }}
                >
                    <img
                        src={livingWithGaImage}
                        alt="grid-home-footer"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: 'block',
                        }}
                    />

                    <Box sx={styles.footerImageOverlay}>
                        <Typography sx={styles.footerImageOverlayLabel}>Guide</Typography>
                        <Typography sx={styles.footerImageOverlayTitle}>Living with<br />Geographic Atrophy</Typography>
                    </Box>

                    <Button
                        variant="contained"
                        sx={{...theme.typography.poppinsBodyBold, position: 'absolute', bottom: 30, right: 30, zIndex: 2, color:'#FFF', textTransform: 'none'}}
                        onClick={() => downloadHandler(livingWithGeographicAtrophyLeaflet)}
                    >
                        View PDF
                    </Button>
                </Box>

                {/* RIGHT SIDE */}
                <Box
                    sx={{
                        flex: 1,
                        position: 'relative',
                        aspectRatio: '16 / 9',
                        overflow: 'hidden',
                    }}
                >
                    <img
                        src={supportingSomeoneWithGaImage}
                        alt="grid-home-footer"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: 'block',
                        }}
                    />
                    <Box sx={styles.footerImageOverlay}>
                        <Typography sx={styles.footerImageOverlayLabel}>Guide</Typography>
                        <Typography sx={styles.footerImageOverlayTitle}>
                            Caring for Someone with<br />
                            Geographic Atrophy
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        sx={{...theme.typography.poppinsBodyBold, position: 'absolute', bottom: 30, right: 30, zIndex: 2, color:'#FFF', textTransform: 'none'}}
                        onClick={() => downloadHandler(caringForSomeoneWithGeographicAtrophy)}
                    >
                        View PDF
                    </Button>
                </Box>
            </Box>

            <Box sx={{backgroundColor: "white",pt:2, pb:6}}>
                <Box sx={{display: "flex", flexDirection: "column", justifyContent: "center", height: "65px", pb:1}}>
                    <Typography sx={{...styles.cardItemMainTitle, backgroundColor: '#fff', color:'#1E1E22', lineHeight: '100%', lineSpacing: '.5%'}}>
                        {"Stay Ahead in GA Detection"}
                    </Typography>
                </Box>

                <Grid container gap={"1rem"} justifyContent="center" mx="10px" mb={"24px"}>
                    {contentCards.map((card) => (
                        <Grid key={card.id} sx={{
                            background: `url(${card.imageSource})`,
                            backgroundSize:  '100%',
                            backgroundPosition: '10% 45%',
                            backgroundRepeat: 'no-repeat',
                            borderRadius: "10px",
                            transition: 'transform 0.2s',
                            '&:hover': {transform: 'scale(1.03)'}
                        }}>
                            <Card
                                sx={{
                                    background: 'linear-gradient(to top, #0D1C2A 28%, #00000000)',
                                    color: '#fff',
                                    borderRadius: 2,
                                    height: {xs: "280px", md: "280px"},
                                    width: {xs: "378px", md: "439px"},
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                <CardActionArea sx={{
                                    display: "flex",
                                    alignItems: 'center',
                                    justifyContent: "center",
                                    height: "100%",
                                    width: "100%"
                                }} onClick={() => handleCardClick(card)}>
                                    <CardContent sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: 'center',
                                        justifyContent: "center",
                                        width: "100%"
                                    }}>
                                        <Typography variant="caption"
                                                    sx={{...theme.typography.poppinsBodyRegular, color: "#fff"}}>
                                            {card.type}
                                        </Typography>
                                        <Box sx={{height: isMobile ? "80px" : "62px", maxHeight: "80px"}}>
                                            <Typography variant="h6" sx={{
                                                px: card.id === 0 ? "60px" : "10px",
                                                mt: "6px", ...theme.typography.poppinsBodyBold,
                                                fontSize: "28px",
                                                fontStyle: "italic",
                                                color: "#fff",
                                                lineHeight: "110%"
                                            }}>
                                                {card.title}
                                            </Typography>
                                        </Box>
                                        <img src={roundBack} style={{width: "42px", height: "42px", marginTop: "15px"}}
                                             alt="round-back"/>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <VideoDialog
                videoUrl={gaVideoUrl}
                showDialog={showDemoVideo}
                onCloseVideoDialog={() => setShowDemoVideo(false)}/>
        </Box>

    )
}
